import axios from "axios";
import { PluginObject } from "vue/types/plugin";

import { constant } from "./ConstantPlugin";
import { utility } from "./UtilityPlugin";

export class API {
  constructor() {}

  private compose(token: null | string = null) {
    if (token) {
      return axios.create({
        baseURL: constant.BASE_API_URL,
        headers: { Authorization: "Bearer " + token },
      });
    }
    return axios.create({
      baseURL: constant.BASE_API_URL,
    });
  }

  public async getUserToken({ email, password }) {
    return utility.tryCatch(
      this.compose().post("/sign-in", { email, password })
    );
  }

  public async registerUser({
    name,
    password,
    email,
    state,
    gender,
    contact_no,
  }) {
    return utility.tryCatch(
      this.compose().post("/register", {
        name,
        password,
        email,
        state,
        gender,
        contact_no,
      })
    );
  }

  public async getUserTokenApi(email: string, password: string) {
    return utility.tryCatch(
      this.compose().post("/sign-in", { email, password })
    );
  }

  public async getUserDetailsApi(token: string | null) {
    return utility.tryCatch(this.compose(token).get("/user_details", {}));
  }

  public async userRegistration(
    type: "A" | "B" | "C" | "voter" | "judge",
    data: any
  ) {
    return utility.tryCatch(this.compose().post(`/register/${type}`, data));
  }

  public async uploadArtApi(
    token: string | null,
    data: FormData,
    uploadProgress: (e?: any) => void
  ) {
    return utility.tryCatch(
      this.compose(token).post("/upload_artwork", data, {
        onUploadProgress: uploadProgress,
      })
    );
  }

  public async downlaodTemplateApi(
    token: string | null,
    category: string,
    downLoadProgress: (e?: any) => void
  ) {
    return utility.tryCatch(
      this.compose(token).get("/template_download?category=" + category, {
        responseType: "blob",
        onDownloadProgress: downLoadProgress,
      })
    );
  }

  public async removeUserMessageApi(token: string | null) {
    return utility.tryCatch(this.compose(token).get("/remove_user_message"));
  }

  public async getApprovedArtsApi(page = 1) {
    return utility.tryCatch(this.compose().get(`/artwork_list?&page=${page}`));
  }

  public async getArtworkDetailApi(id: number) {
    return utility.tryCatch(this.compose().post("/artwork-details", { id }));
  }

  public async voteApi(token: string | null, id: number) {
    return utility.tryCatch(
      this.compose(token).post("/vote", {
        artwork_id: id,
      })
    );
  }
  public async resendVerifyApi(email: string) {
    return utility.tryCatch(
      this.compose().post("/resend-verification-email", {
        email,
      })
    );
  }
  public async resetPassEmailApi(email: string) {
    return utility.tryCatch(
      this.compose().post("/forget-password", {
        email,
      })
    );
  }

  public async resetPassApi(token: string, email: string, password: string) {
    return utility.tryCatch(
      this.compose().post("/reset-password", {
        token,
        email,
        password,
      })
    );
  }

  public async searchApi(keyword: string, page = 1) {
    return utility.tryCatch(
      this.compose().get("/artwork_list?search=" + keyword + "&page=" + page)
    );
  }
}

export const api = new API();

export const ApiPlugin: PluginObject<any> = {
  install: (vue, options) => {
    vue.prototype.$api = api;
    vue.prototype.$axios = axios;
  },
};
